<div class="mt-responsive">
    <router-outlet>
    </router-outlet>
</div>